import { useMutation } from '@tanstack/react-query';

import ExternalService from '../services/ExternalService/ExternalApiService';
import { type IDPConfig, type IDPConfigKosmos } from '../services/types';

interface ErrorResponse {
  message?: string;
  errorMessage?: string;
}

export class ApiError extends Error {
  status: number;

  details: ErrorResponse | undefined;

  constructor(message: string, status: number, details: ErrorResponse) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.details = details;
    Object.setPrototypeOf(this, ApiError.prototype); // Ensure proper inheritance
  }
}
interface ApiResponse {
  success: boolean; // Indicates if the API call was successful
  errorMessage: string; // Optional message from the server
  data: IDPConfig | IDPConfigKosmos; // The actual data returned by the API
  error: ErrorResponse; // Error details in case of failure
  status: number;
  ok?: boolean;
}

/**
 * Posts IDP configuration to the external service.
 *
 * @param {IDPConfig | IDPConfigKosmos} vendor - The vendor-specific IDP configuration to be posted.
 */
const postConfig = async (vendor: IDPConfig | IDPConfigKosmos) => {
  const response = (await ExternalService.postIDPConfig(vendor)) as ApiResponse;

  // if (!response.data && !response.ok) {
  //   throw new ApiError(
  //     `Error ${response.errorMessage}: ${response.status}`,
  //     response.status,
  //     response.error
  //   );
  // }

  return response;
};

/**
 * Custom hook to perform the postConfig mutation.
 *
 * @returns {UseMutationResult<any, unknown, IDPConfig | IDPConfigKosmos, unknown>} The result of the mutation.
 */
const usePostIDProvider = () =>
  useMutation({
    mutationFn: (vendor: IDPConfig | IDPConfigKosmos) => postConfig(vendor),
  });

export default usePostIDProvider;
